{
  "valid": "Gültig"
}
